import React, { useEffect, useRef } from 'react';

import type { Props as AllProps } from './types';

type Props = Pick<AllProps, 'allSelected' | 'isIndeterminate' | 'toggleSelectAll'>;

export default function MapListHeaderSelectAllCheckbox({
  allSelected,
  isIndeterminate,
  toggleSelectAll,
}: Props) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current && isIndeterminate != null) {
      ref.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <div>
      <input
        checked={allSelected}
        className="form-check-input"
        ref={ref}
        type="checkbox"
        onChange={toggleSelectAll}
      />
    </div>
  );
}
